import { useLazyQuery, useMutation } from "@apollo/client";
import { CLOSE_COMPANION_SESSION } from "@graphql/mutations/CloseCompanionSession";
import { CREATE_COMPANION_SESSION } from "@graphql/mutations/CreateCompanionSession";
import GET_COMPANION_SESSION from "@graphql/queries/GetCompanionSession";
import { useTeam, useWatchUserWsEvent } from "@hooks";
import { useCompanion } from "@hooks/use-companion";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import Record from "../common/record/Record";
import PageTitle from "../layout/PageTitle";

export default function CompanionDashboard() {
  const { companion } = useFlags();
  const [isRecording, setIsRecording] = useState(false);
  const { currentTeam } = useTeam();
  const [createCompanionSession] = useMutation(
    CREATE_COMPANION_SESSION,
  );
  const [closeCompanionSession] = useMutation(
    CLOSE_COMPANION_SESSION,
  );
  const [getCompanionSession, { refetch: refetchCompanionSession }] =
    useLazyQuery(GET_COMPANION_SESSION);
  const {
    joinRoom,
    leaveRoom,
    companionSession,
    setCompanionSession,
  } = useCompanion();

  const refetchAndUpdateCompanionSession = async () => {
    if (!companionSession?.companionSessionUuid) {
      return;
    }
    const { data } = await refetchCompanionSession();
    setCompanionSession(data?.companionSession);
  };

  useWatchUserWsEvent({
    onMessage: refetchAndUpdateCompanionSession,
    eventName: "companion_session_update",
  });

  useEffect(async () => {
    if (isRecording && !companionSession?.companionSessionUuid) {
      const { data } = await createCompanionSession({
        variables: { teamUuid: currentTeam?.uuid },
      });
      joinRoom(data?.createCompanionSession?.companionSessionUuid);
      const { data: companionSessionData } =
        await getCompanionSession({
          variables: {
            companionSessionUuid:
              data?.createCompanionSession?.companionSessionUuid,
          },
        });
      setCompanionSession(companionSessionData?.companionSession);
    } else if (
      !isRecording &&
      companionSession?.companionSessionUuid
    ) {
      setCompanionSession(null);
      await closeCompanionSession({
        variables: {
          companionSessionUuid:
            companionSession?.companionSessionUuid,
        },
      });
      leaveRoom();
    }
  }, [isRecording]);

  async function createNewNote(
    audioStorageLink,
    storageObjectName,
    jobType,
    syncedRecordingUUID,
    isNoteFromFileUpload,
    recordingAs,
  ) {
    // TODO do something with the note
    console.log(
      audioStorageLink,
      storageObjectName,
      jobType,
      syncedRecordingUUID,
      isNoteFromFileUpload,
      recordingAs,
    );
    await new Promise((r) => setTimeout(r, 5000));
  }

  if (!companion) {
    return null;
  }

  return (
    <>
      <PageTitle title="Companion" />

      <div className="flex">
        <div className="flex-1">
          <CompanionRecordingSection
            isRecording={isRecording}
            setIsRecording={setIsRecording}
            createNewNote={createNewNote}
          />
        </div>
      </div>
    </>
  );
}

function CompanionRecordingSection({
  isRecording,
  setIsRecording,
  createNewNote,
}) {
  const { control } = useForm();

  return (
    <div className="p-4">
      <Record
        isRecording={isRecording}
        setIsRecording={setIsRecording}
        control={control}
        createNewNote={createNewNote}
        shouldShowTitleInput={true}
        shouldUseSmallSize={false}
        shouldShowTypeDropdown={true}
        shouldShowRecordAs={true}
      />
    </div>
  );
}
